<template>
  <div class="page_content" aria-label="Major Minor Upload Page Content">
    <div>
      <div class="hidden-container">
        <form method="POST" id="multipleFileUploadForm" enctype="multipart/form-data" v-on:submit.prevent>
          <input type="file" id="fileListId" ref="fileInput" name="fileList" rel="multipleFile" @change="fileToBeUploaded" aria-label="select file"/>
        </form>
      </div>
      <div class="row page-heading">
        <div class="col-7 input module_heading" role="heading" aria-level="1">
          <span class="module_icon icon-stream"></span>
          <span class="module_type_name">Major Minor Upload</span>

        </div>
        <div class="col-5 btn_container">
          <b-btn @click="uploadMajorMinorClicked" aria-label="upload">upload</b-btn>
          <b-btn @click="cancelClicked" aria-label="cancel">cancel</b-btn>
        </div>
      </div>

      <div class="create-section">
        <div class="content-section">
          <div class="row content-row">
            <div class="col-4 form-label">
              <label for="chooseFileButton">Select CSV file</label>
            </div>
            <div class="col-8">
              <b-btn id="chooseFileButton" @click="chooseFileClicked">Choose File</b-btn>
              <span class="selected-file-name" v-if="fileUploadArray.length > 0">{{fileUploadArray[0].fileName}}</span>
              <span class="selected-file-name" v-else>No file chosen</span>
            </div>
          </div>

          <div class="sample-csv-link">
            <a href="../../help/views/sampleFiles/major_minor.csv" aria-label="click here to get a copy of the sample csv file">Click here</a> <span class="link-text">to get a copy of the sample csv file.</span>
          </div>
        </div>
      </div>
    </div>

    <div class="modal_container modal_alart">
        <b-modal class="" ref="uploadErrorModal" :title="'Error Message!'" :header-bg-variant="'competency-upload-exists-modal'" ok-disabled cancel-diasbled hide-header-close no-close-on-backdrop no-close-on-esc centered>
            <div class="text-center">
                <span v-html="errorMessage"></span>
            </div>
          <div slot="modal-header" class="header-section">
            <div class="ic ic-hd"></div>
            <div class="head_txt">Error Message!</div>
            <button type="button" class="btn_close" @click="hideUploadErrorModal" aria-label="close">
              <span class="ic-close"></span>
            </button>
          </div>
          <div slot="modal-footer" class="w-100">
              <b-button @click="hideUploadErrorModal" class="btn button-primary float-right mr-2" aria-label="no"> ok </b-button>
          </div>
        </b-modal>
    </div>

  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import _ from 'lodash'
import Papa from 'papaparse'

var isCsvFile = function (file) {
  var fileName = file.name
  var regEx = /(.csv)$/i
  return regEx.test(fileName)
}

var getFileName = function (fileName) {
  if (!fileName && fileName !== null) {
    return null
  }
  return fileName.replace(/\.\w+$/g, '')
}

var getUpdatedFileName = function (title, fileName) {
  var ext = fileName.substr((~-fileName.lastIndexOf('.') >>> 0) + 2)
  if (ext !== '' || ext !== null) {
    return (title + '.' + ext)
  } else {
    return fileName
  }
}

var FileObject = function (title, file, size, timestamp, type) {
  this.title = getFileName(title)
  this.file = file
  this.fileName = getUpdatedFileName(this.title, title)
  this.size = size
  this.contentFileType = type
  this.timestamp = timestamp
  this.id = timestamp
}

export default {
  name: 'major-minor-upload',
  props: ['isWidgetAdminDash'],
  data: () => {
    return {
      majorMinorData: '',
      fileUploadArray: [],
      institutionId: '',
      userId: '',
      errorMessage: ''
    }
  },
  mounted () {
    this.loadDataForMajorMinorUpload()
  },

  methods: {
    ...mapActions([
      'uploadMajorMinorCsvFile',
      'loadPublicInstitutionDetail',
      'loadPermission'
    ]),
    loadDataForMajorMinorUpload () {
      let userObj = JSON.parse(localStorage.getItem('userobj'))
      this.userId = userObj.uuid
      this.institutionId = userObj.institutionId
      this.loadPermission()
    },
    uploadMajorMinorClicked () {
      if (this.fileUploadArray.length <= 0) {
        this.$notify({
          group: 'notify',
          type: 'warn',
          title: '',
          text: 'Please choose a valid CSV file to upload majorMinors.'
        })
        return
      }
      this.uploadFiles()
    },
    dataIsValid (majorMinor) {
      return true
    },
    cancelUploadClicked () {
      this.fileUploadArray = []
    },
    chooseFileClicked () {
      this.clearFilePath()
      let sel = 'rel=multipleFile'
      $('input[type=file][' + sel + ']').click()
    },
    fileToBeUploaded (ev) {
      var files = ev.target.files || ev.dataTransfer.files
      if (!files.length) {
        return
      }
      if (!isCsvFile(files[0])) {
        this.clearFilePath()
        this.errorMessage = 'Please Select CSV file'
        this.$refs.uploadErrorModal.show()
        return
      }
      this.prepareFileUploadArray(files)
    },
    prepareFileUploadArray (files) {
      if (files) {
        var timestamp = new Date().getTime()
        for (var i = 0; i < files.length; i++) {
          timestamp = timestamp + i
          this.addFileToUploadArray(files[i], timestamp)
        }
      }
    },
    addFileToUploadArray (newFile, timestamp) {
      var isFound = _.find(this.fileUploadArray, function (file) {
        return ((newFile.name === file.title) && (newFile.size === file.size))
      })

      if (!isFound) {
        this.fileUploadArray.push(new FileObject(newFile.name, newFile, newFile.size, timestamp, newFile.type))
      }
    },
    uploadFiles () {
      if (this.fileUploadArray.length <= 0) {
        return
      }
      let fileObject = this.fileUploadArray[0]
      this.readCsvFileAndShowWarningIfExists(fileObject)
    },
    readCsvFileAndShowWarningIfExists (fileObject) {
      let self = this
      let headers = ['title', 'cipCode']
      let identifiedHeaders = ['title', 'cipcode', 'pragyacipcode', 'code', 'programlevel', 'category', 'subcategory', 'college', 'type', 'thumbnailuri', 'relatedcipcodes', 'relatedsoccodes', 'description', 'concentrations', 'pathways',  'relatedprogramcodes', 'customtags','disablecareersort',
       'statedefault', 'msadefault']
      let reader = new FileReader()
      reader.onload = fileLoadedEvent => {
        Papa.parse(fileLoadedEvent.target.result, {
          header: true,
          skipEmptyLines: true,
          complete (results) {
            let missing = []
            let fields = (results.meta.fields.length > 0) ? _.map(results.meta.fields, (v) => { return v.toLowerCase() }) : []
            $.each(headers, (i, val) => {
              if (!_.includes(fields, val.toLowerCase())) {
                if (missing.length === 0) {
                  missing.push(val)
                } else {
                  missing.push(' ' + val)
                }
              }
            })
            let unidentifed = []
            $.each(fields, (i, val) => {
              if (!_.includes(identifiedHeaders, val.toLowerCase())) {
                if (unidentifed.length === 0) {
                  unidentifed.push(val)
                } else {
                  unidentifed.push(' ' + val)
                }
              }
            })

            let isHeaderMissing = (missing.length > 0)
            if (isHeaderMissing) {
              self.errorMessage = 'Headers <strong>[' + missing + ']</strong> are missing.<BR><BR>Please fix the error and re-upload.'
            }

            let ifUnidentifiedHeader = (unidentifed.length > 0)
            if (ifUnidentifiedHeader) {
              self.errorMessage = 'These headers are not allowed <strong>[' + unidentifed + ']</strong>. <BR><BR> Headers must be one of these values: [' + identifiedHeaders + '].<BR><BR>Please fix the error and re-upload.'
            }
            if (self.errorMessage.length > 0) {
              self.$refs.uploadErrorModal.show()
            } else {
              let data = new FormData()
              data.append('file', fileObject.file, fileObject.title)
              self.uploadMajorMinorCsvFile({fileData: data}).then(response => {
                self.fileUploadArray = []
                return self.$router.push({ name: 'taskMonitor', params: { taskId: response.taskId } })
              })
            }
          },
          error (errors) {
            console.log('error: ', errors)
          }
        })
      }
      reader.readAsText(fileObject.file)
    },
    hideUploadErrorModal () {
      this.$refs.uploadErrorModal.hide()
      this.errorMessage = ''
      this.clearFilePath()
    },
    clearFilePath () {
      this.fileUploadArray = []
      const input = this.$refs.fileInput
      input.type = 'text'
      input.type = 'file'
    },
    cancelClicked () {
      if (this.isWidgetAdminDash) {
        return this.$router.push({name: 'widgetAdminDashboard'})
      }
      return this.$router.push({name: 'majorMinorList'})
    }
  },
  computed: {
    ...mapState({
      'permission': state => state.user.permission,
      'publicInstitution': state => state.institution.publicInstitution
    })
  },
  watch: {
  }
}
</script>

<style scoped>
.hidden-container {
  visibility: hidden;
  height: 1px;
}
</style>



// WEBPACK FOOTER //
// src/app/programguide/components/MajorMinorUpload.vue